// components
import CircularProgress from '@mui/material/CircularProgress';
import NavMenu from '../components/NavMenu';

// hooks
import useProducts from '../hooks/useProducts';
import { useLocation } from 'react-router-dom';
import styles from './productStyles';
import { Box, Grid, Typography } from '@mui/material';
import ProductCard from '../components/ProductCard';
import { IProduct } from '../types/Product';
import Footer from '../components/ui/Footer';
import { useScreenResolution } from '../utils/utils';

interface LocationState {
  categoryId: string;
}

const Products = () => {
  const location = useLocation();
  const locationState = location.state as LocationState;
  const categoryId = locationState?.categoryId;
  const { data, loading, error } = useProducts(categoryId);
  const isDesktop = useScreenResolution();

  const renderError = error && (
    <Box textAlign="center" mt={10}>
      <Typography variant="subtitle1">Something went wrong!</Typography>
    </Box>
  );
  const renderContent = () => {
    if (loading && data.length === 0)
      return (
        <Box textAlign="center" my={5}>
          <CircularProgress />
        </Box>
      );
    return (
      <Grid container spacing={3}>
        {data &&
          data.map((item: IProduct) => (
            <Grid item xs={12} md={6} lg={4} key={`${item.id}${item.title}`}>
              <ProductCard product={item} />
            </Grid>
          ))}
      </Grid>
    );
  };

  return (
    <>
      <NavMenu />
      <Box p={2} sx={styles.container}>
        {renderError}
        {renderContent()}
      </Box>
      {isDesktop && <Footer isFixed />}
    </>
  );
};

export default Products;
